/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StoreImport } from './routes/store'
import { Route as TasksImport } from './routes/tasks'
import { Route as IndexImport } from './routes/index'
import { Route as DocsIndexImport } from './routes/docs.index'
import { Route as DocsMcpIndexImport } from './routes/docs.mcp.index'
import { Route as DocsSplatImport } from './routes/docs.$'

// Create/Update Routes

const StoreRoute = StoreImport.update({
    id: '/store',
    path: '/store',
    getParentRoute: () => rootRoute,
} as any)

const TasksRoute = TasksImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => rootRoute,
} as any)

const DocsIndexRoute = DocsIndexImport.update({
    id: '/docs/',
    path: '/docs/',
    getParentRoute: () => rootRoute,
} as any)

const DocsMcpIndexRoute = DocsMcpIndexImport.update({
    id: '/docs/mcp/',
    path: '/docs/mcp/',
    getParentRoute: () => rootRoute,
} as any)

const DocsSplatRoute = DocsSplatImport.update({
    id: '/docs/$',
    path: '/docs/$',
    getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
    interface FileRoutesByPath {
        '/': {
            id: '/'
            path: '/'
            fullPath: '/'
            preLoaderRoute: typeof IndexImport
            parentRoute: typeof rootRoute
        }
        '/store': {
            id: '/store'
            path: '/store'
            fullPath: '/store'
            preLoaderRoute: typeof StoreImport
            parentRoute: typeof rootRoute
        }
        '/tasks': {
            id: '/tasks'
            path: '/tasks'
            fullPath: '/tasks'
            preLoaderRoute: typeof TasksImport
            parentRoute: typeof rootRoute
        }
        '/docs/': {
            id: '/docs/'
            path: '/docs'
            fullPath: '/docs'
            preLoaderRoute: typeof DocsIndexImport
            parentRoute: typeof rootRoute
        }
        '/docs/mcp/': {
            id: '/docs/mcp/'
            path: '/docs/mcp'
            fullPath: '/docs/mcp'
            preLoaderRoute: typeof DocsMcpIndexImport
            parentRoute: typeof rootRoute
        }
        '/docs/$': {
            id: '/docs/$'
            path: '/docs/$'
            fullPath: '/docs/$'
            preLoaderRoute: typeof DocsSplatImport
            parentRoute: typeof rootRoute
        }
    }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
    '/': typeof IndexRoute
    '/store': typeof StoreRoute
    '/tasks': typeof TasksRoute
    '/docs': typeof DocsIndexRoute
    '/docs/mcp': typeof DocsMcpIndexRoute
    '/docs/$': typeof DocsSplatRoute
}

export interface FileRoutesByTo {
    '/': typeof IndexRoute
    '/store': typeof StoreRoute
    '/tasks': typeof TasksRoute
    '/docs': typeof DocsIndexRoute
    '/docs/mcp': typeof DocsMcpIndexRoute
    '/docs/$': typeof DocsSplatRoute
}

export interface FileRoutesById {
    __root__: typeof rootRoute
    '/': typeof IndexRoute
    '/store': typeof StoreRoute
    '/tasks': typeof TasksRoute
    '/docs/': typeof DocsIndexRoute
    '/docs/mcp/': typeof DocsMcpIndexRoute
    '/docs/$': typeof DocsSplatRoute
}

export interface FileRouteTypes {
    fileRoutesByFullPath: FileRoutesByFullPath
    fullPaths: '/' | '/store' | '/tasks' | '/docs' | '/docs/mcp' | '/docs/$'
    fileRoutesByTo: FileRoutesByTo
    to: '/' | '/store' | '/tasks' | '/docs' | '/docs/mcp' | '/docs/$'
    id: '__root__' | '/' | '/store' | '/tasks' | '/docs/' | '/docs/mcp/' | '/docs/$'
    fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
    IndexRoute: typeof IndexRoute
    StoreRoute: typeof StoreRoute
    TasksRoute: typeof TasksRoute
    DocsIndexRoute: typeof DocsIndexRoute
    DocsMcpIndexRoute: typeof DocsMcpIndexRoute
    DocsSplatRoute: typeof DocsSplatRoute
}

const rootRouteChildren: RootRouteChildren = {
    IndexRoute: IndexRoute,
    StoreRoute: StoreRoute,
    TasksRoute: TasksRoute,
    DocsIndexRoute: DocsIndexRoute,
    DocsMcpIndexRoute: DocsMcpIndexRoute,
    DocsSplatRoute: DocsSplatRoute,
}

export const routeTree = rootRoute
    ._addFileChildren(rootRouteChildren)
    ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/store",
        "/tasks",
        "/docs/",
        "/docs/mcp/",
        "/docs/$"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/store": {
      "filePath": "store.tsx"
    },
    "/tasks": {
      "filePath": "tasks.tsx"
    },
    "/docs/": {
      "filePath": "docs.index.tsx"
    },
    "/docs/mcp/": {
      "filePath": "docs.mcp.index.tsx"
    },
    "/docs/$": {
      "filePath": "docs.$.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
